module.exports = __webpack_public_path__ + "img/Dantam Bridal 01.83f29ce3.jpg";